// @flow

/**
 * Cookie consent copy.
 *
 * Following this repo's convention, `defaultMessage` holds the RU source text
 * (RU is the app's DEFAULT_LOCALE — see src/providers/Intl) and the RO
 * translation lives in src/translations/locales/ro.json under the same ids.
 * Both were taken verbatim from 999-web-app's messages/{ru,ro}.json `cc_*` keys
 * so the wording stays identical across 999.md and business.999.md.
 *
 * buildConfig.js consumes these through a small `t(key)` adapter, so the keys
 * below are also the names used there.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  consentTitle: {
    id: 'cookieConsent.title',
    defaultMessage: 'Мы ценим твою конфиденциальность',
  },
  consentDescription: {
    id: 'cookieConsent.description',
    defaultMessage:
      'Эта Политика в отношении файлов cookie применяется к cookie и другим подобным технологиям, а также ко всем веб-страницам и мобильным приложениям, принадлежащим 999.md. Необязательные cookie используются только после получения твоего согласия. Ты можешь отозвать или изменить своё согласие в любой момент в Настройках cookie.',
  },
  btnAcceptAll: {
    id: 'cookieConsent.btn.acceptAll',
    defaultMessage: 'Принять все',
  },
  btnAcceptNecessary: {
    id: 'cookieConsent.btn.acceptNecessary',
    defaultMessage: 'Принять только необходимые',
  },
  // Used by BOTH modals since CS9-537; btnAcceptNecessary above is kept only so
  // the string stays translated if the softer wording is ever wanted back.
  btnRejectAll: {
    id: 'cookieConsent.btn.rejectAll',
    defaultMessage: 'Отклонить все',
  },
  btnCustomize: {
    id: 'cookieConsent.btn.customize',
    defaultMessage: 'Настроить',
  },
  btnSave: {
    id: 'cookieConsent.btn.save',
    defaultMessage: 'Сохранить настройки',
  },
  close: {
    id: 'cookieConsent.close',
    defaultMessage: 'Закрыть',
  },
  linkCookiePolicy: {
    id: 'cookieConsent.link.cookiePolicy',
    defaultMessage: 'Политика Cookie',
  },
  linkPrivacyPolicy: {
    id: 'cookieConsent.link.privacyPolicy',
    defaultMessage: 'Политика конфиденциальности',
  },
  prefTitle: {
    id: 'cookieConsent.pref.title',
    defaultMessage: 'Типы файлов cookie',
  },
  prefIntroTitle: {
    id: 'cookieConsent.pref.introTitle',
    defaultMessage: 'Используемые cookie — список cookie / срок их хранения',
  },
  prefStorageNote: {
    id: 'cookieConsent.pref.storageNote',
    defaultMessage: 'Твои настройки cookie хранятся {months} месяцев.',
  },
  tableName: {
    id: 'cookieConsent.table.name',
    defaultMessage: 'Название',
  },
  tableDomain: {
    id: 'cookieConsent.table.domain',
    defaultMessage: 'Домен',
  },
  tableDescription: {
    id: 'cookieConsent.table.description',
    defaultMessage: 'Описание',
  },
  tableExpiration: {
    id: 'cookieConsent.table.expiration',
    defaultMessage: 'Срок действия',
  },
  catNecessaryTitle: {
    id: 'cookieConsent.cat.necessary.title',
    defaultMessage: 'Строго необходимые cookie',
  },
  catNecessaryDesc: {
    id: 'cookieConsent.cat.necessary.desc',
    defaultMessage:
      'Эти файлы cookie необходимы для работы сайта и не могут быть отключены в наших системах. Обычно они устанавливаются только в ответ на твои действия, равнозначные запросу услуг, — например, выбор настроек конфиденциальности, вход в систему или заполнение формы. Ты можешь настроить браузер так, чтобы он блокировал эти cookie или уведомлял о них; однако в результате некоторые части сайта могут стать недоступными.',
  },
  catFunctionalityTitle: {
    id: 'cookieConsent.cat.functionality.title',
    defaultMessage: 'Функциональные cookie',
  },
  catFunctionalityDesc: {
    id: 'cookieConsent.cat.functionality.desc',
    defaultMessage:
      'Эти cookie обеспечивают расширенные функции и персонализацию — например, заказ звонка и формы обратной связи. Они могут устанавливаться нами или сторонними поставщиками, чьи сервисы мы добавили на наши страницы. Некоторые или все эти функции могут работать некорректно, если ты не дашь согласие на использование функциональных cookie.',
  },
  catAnalyticsTitle: {
    id: 'cookieConsent.cat.analytics.title',
    defaultMessage: 'Аналитические cookie',
  },
  catAnalyticsDesc: {
    id: 'cookieConsent.cat.analytics.desc',
    defaultMessage:
      'Эти cookie помогают нам понять, как посетители взаимодействуют с сайтом, собирая информацию о количестве посещений, источниках трафика, просмотренных страницах и поведении пользователей. Собранные данные агрегируются и обезличиваются, когда это возможно, и используются в основном для улучшения функциональности, производительности и удобства сайта. Отключение этих cookie может ограничить нашу возможность анализировать и улучшать работу сайта.',
  },
  settingsLink: {
    id: 'cookieConsent.settingsLink',
    defaultMessage: 'Настройки cookie',
  },
});
